import React from "react";

import { ToastProvider } from "@puzzle/ui";
import { VerifyRouteAccessProvider } from "lib/VerifyRouteAccessProvider";

import { PendingConnectionsProvider } from "components/integrations/shared/PendingConnectionsProvider";
import { ActiveCompanyProvider } from "components/companies/ActiveCompanyProvider";
import { FitTestProvider } from "components/fitTest/useFitTest";

// TODO: Explore if we can load this only in selected pages
// Right now we seem to use 'useFinancialInstitutions' in mostly integrations and settings pages
// https://linear.app/puzzlefin/issue/PER-287/explore-removing-financialinstitutionsprovider-from-the-appproviders
import { FinancialInstitutionsProvider } from "components/integrations/shared/FinancialInstitutionsProvider";

import { LazyLoadingProvider } from "domains/app/LazyLoadingProvider/LazyLoadingProvider";
import { UserTracker } from "domains/app/components/UserTracker/UserTracker";

type DataProvidersProps = React.PropsWithChildren<unknown>;

const DataProviders = ({ children }: DataProvidersProps) => {
  return (
    <LazyLoadingProvider>
      <ActiveCompanyProvider>
        <FinancialInstitutionsProvider>
          <PendingConnectionsProvider>
            <FitTestProvider>
              <VerifyRouteAccessProvider>
                <UserTracker />
                {children}
              </VerifyRouteAccessProvider>
            </FitTestProvider>
          </PendingConnectionsProvider>
        </FinancialInstitutionsProvider>
      </ActiveCompanyProvider>
    </LazyLoadingProvider>
  );
};

const Noop = ({ children }: React.PropsWithChildren<unknown>) => <>{children}</>;

export const AppProviders = ({
  children,
  disableDataProviders = false,
}: React.PropsWithChildren<{
  disableDataProviders?: boolean;
}>) => {
  const OtherProviders = disableDataProviders ? Noop : DataProviders;

  return (
    <ToastProvider>
      <OtherProviders>{children}</OtherProviders>
    </ToastProvider>
  );
};
